import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'; 
import { ProjectConst } from '@ascschool/project/config/const';
import { TranslateService } from '@ngx-translate/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { JProject } from '@ascschool/interface/project';
import { NzTableSortOrder, NzTableSortFn, NzTableFilterList, NzTableFilterFn } from 'ng-zorro-antd/table';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
interface DataItem {
  name: string;
  age: number;
  nickName: string;
  employee: boolean;
}
interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn | null;
  listOfFilter: NzTableFilterList | null;
  filterFn: NzTableFilterFn | null;
  filterMultiple: boolean;
  sortDirections: NzTableSortOrder[];
}
@Component({
  selector: 'app-popup-info',
  templateUrl: './popup-info.component.html',
  styleUrls: ['./popup-info.component.scss']
})

export class PopupInfoComponent implements OnInit {
  keyUpCode: number = 38;
  ketDownCode: number = 40;
  keyLeftCode: number = 37;
  keyRightCode: number = 39;
  project: JProject;
  isOpen:boolean = false; 
  
  get breadcrumbs(): string[] {
    return [ProjectConst.Projects, 'Sample 7'];
  }
  constructor(private translate: TranslateService,
              private modalService: NzModalService,
              private drawerService: NzDrawerService,
              private msg: NzMessageService,
              private modal: NzModalRef
  ) { }

  ngOnInit() {
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
 
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  // tslint:disable-next-line: member-ordering
  filterEmloyee = [
    { text: 'male', value: 'male' },
    { text: 'female', value: 'female' }
  ];
  // tslint:disable-next-line: member-ordering
  listOfColumns: ColumnItem[] = [
    {
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => a.name.localeCompare(b.name),
      sortDirections: ['ascend', null],
      listOfFilter: null,
      filterFn: null,
      filterMultiple: false
    },
    {
      name: 'Age',
      sortOrder: 'descend',
      sortFn: (a: DataItem, b: DataItem) => a.age - b.age,
      sortDirections: ['ascend','descend', null],
      listOfFilter: null,
      filterFn: null,
      filterMultiple: true
    },
    {
      name: 'Nickname',
      sortOrder: null,
      sortDirections: ['ascend', 'descend', null],
      sortFn: (a: DataItem, b: DataItem) => a.nickName.length - b.nickName.length,
      filterMultiple: false,
      listOfFilter: null,
      filterFn: (nickName: string, item: DataItem) => item.nickName.indexOf(nickName) !== -1
    },
    {
      name: 'employee',
      sortOrder: null,
      sortDirections: ['ascend', 'descend', null],
      sortFn: null,
      filterMultiple: false,
      listOfFilter: [
        { text: 'có', value: true },
        { text: 'không', value: false }
      ],
      filterFn: (employee: boolean, item: DataItem) => item.employee === employee
    }
  ];
  listOfData: DataItem[] = [
    {
      name: 'John Brown2',
      age: 32,
      nickName: 'Hello4',
      employee: true
    },
    {
      name: 'John Brown1',
      age: 33,
      nickName: 'Hello3',
      employee: false
    },
    {
      name: 'John Brown3',
      age: 34,
      nickName: 'Hello1',
      employee: true
    },
    {
      name: 'John Brown4',
      age: 36,
      nickName: 'Hello2',
      employee: true
    }
    ,
    {
      name: 'John Brown4',
      age: 36,
      nickName: 'Hello2',
      employee: true
    }
  ];
  onclickOpen(){
    this.isOpen = !this.isOpen;
  }
  deleteRow(){

  }
}

